export default "__VITE_ASSET__e0e210b6__"